// extracted by mini-css-extract-plugin
export default {"collapsible":"collapsible__uNMfH","collapsed":"collapsed__RnNtx","collapseContainer":"collapseContainer__Gz7S9","collapseIcon":"collapseIcon__gPvb_"};